// components/AttachmentManager.jsx
import React, { useState, useEffect } from "react";
import { requestAPI } from "../services/api";
import styles from "./AttachmentManager.module.css"; // Create this CSS module

const AttachmentManager = ({ requestId }) => {
  const [attachments, setAttachments] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchAttachments = async () => {
      if (!requestId) return;

      setLoading(true);
      try {
        const response = await requestAPI.getAttachments(requestId);
        setAttachments(response.data);
      } catch (error) {
        console.error("Failed to fetch attachments:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAttachments();
  }, [requestId]);

  const handleDownload = async (attachmentId, fileName) => {
    try {
      const response = await requestAPI.downloadAttachment(attachmentId);
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  if (loading) {
    return <div className={styles.loading}>Loading attachments...</div>;
  }

  return (
    <div className={styles.container}>
      {attachments.length === 0 ? (
        <p className={styles.empty}>No attachments available</p>
      ) : (
        <div className={styles.attachmentsList}>
          {attachments.map((attachment) => (
            <div
              key={attachment.id}
              className={styles.attachmentItem}
              onClick={() =>
                handleDownload(attachment.id, attachment.file_name)
              }
            >
              <div className={styles.fileRow}>
                <div className={styles.fileName}>{attachment.file_name}</div>
                <div className={styles.actions}>
                  <div className={styles.iconButton}>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="7 10 12 15 17 10" />
                      <line x1="12" y1="15" x2="12" y2="3" />
                    </svg>
                  </div>
                  {attachment.data_url && (
                    <a
                      href={attachment.data_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.viewButton}
                    >
                      View
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AttachmentManager;
